<template>
    <div class="section-FAQ">
        <div class="container">
            <div class="row justify-content-center">
                <div class="title">
                    <h3 class="h1 p-title p-black p-center mb-0 relawayBold">FAQ</h3>
                </div>
            </div>
                    <div class="faq-list">
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="faq__item"
                                     v-for="(item, index) in getHalfFaq(1)"
                                     :class="{ 'open' : index ===  current_index}"
                                >
                                    <div class="row">
                                        <div class="col-10" @click="openFaq(index)">
                                            <div class="titles">
                                                <p class="min-med p-dgrey  mb-0 p-bold">{{index}}{{item.title}}</p>
                                            </div>
                                            <transition name="fade">
                                                <div class="content" v-if="index ===  current_index">
                                                    <p class="min-min p-dgrey mb-0">{{item.content}}</p>
                                                </div>
                                            </transition>
                                        </div>
                                        <div class="col-2">
                                            <div class="icon" @click="openFaq(index)">
                                                <span></span>
                                                <span></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 second__section" >
                                <div class="faq__item"
                                     v-for="(item, index) in getHalfFaq()"
                                     :class="{ 'open' : index ===  current_index}"
                                >
                                    <div class="row">
                                        <div class="col-10" @click="openFaq(item.id)">
                                            <div class="titles">
                                                <p class="min-med p-dgrey  mb-0 p-bold">{{item.id}}{{item.title}}</p>
                                            </div>
                                            <transition name="fade">
                                                <div class="content" v-if="item.id ===  current_index">
                                                    <p class="min-min p-dgrey mb-0">{{item.content}}</p>
                                                </div>
                                            </transition>
                                        </div>
                                        <div class="col-2">
                                            <div class="icon" @click="openFaq(index)">
                                                <span></span>
                                                <span></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


        </div>
    </div>
</template>

<script>
    export default {
        name: "Faq",
        data:function () {
            return {
                faq: faq_data,
                current_index: '',
            }
        },
        methods: {
            openFaq: function(index){
                if(index === this.current_index){
                    this.current_index = '';
                } else {
                    this.current_index = index;
                }
            },
            getHalfFaq(type){
                let count = Math.floor(this.faq.length/2);
                if(type === 1){
                    return this.faq.slice( 0, count + 1);
                } else {
                    return this.faq.slice( count)
                }

            }
        },


    }
    let faq_data = [
        {
            id: 1,
            title: "1 Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut",
            content: "ud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur"
        },
        {
            id: 2,
            title: "2 Lorem ipsum dolor sit amet, consectetur ",
            content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur"
        },
        {
            id: 3,
            title: "3 Lorem ipsum dolor ",
            content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur"
        },
        {
            id: 4,
            title: "4 Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed ",
            content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur"
        },
        {
            id: 5,
            title: "5 Lorem ipsum dolor sit amet, consectetur  eiusmod tempor incididunt u",
            content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur"
        },
    ]





</script>
